export const colorPalette = {
    white: "#FFFFFF",
    black: "#00284d",
    gray: {
      100: "#F9FAFB",
      200: "#F6F7F9",
      300: "#E0E4EB",
      400: "#B3BAC6",
      500: "#667085"
    },
    primary: {
      100: "#E5F3FF",
      300: "#cce7ff",
      400: "#66b7ff",
      500: "#006dcc",
      600: "#004685",
      700: "#00305b"
    },
    secondary: {
      100: "#eef9f9",
      300: "#a3dcdb",
      500: "#69c8c5",
      600: "#1a8096",
      700: "#00ffd5"
    },
    accent : {
        100 : "#00FFD5",
        500 : "#99FFEE"
    },
    error: {
      100: "#FFF1F0",
      500: "#f04438",
      700: "#960703"
    },
    warning: {
      100: "#fef0c7",
      500: "#fdb022",
      700: "#b54708"
    },
    success: {
      100: "#ECFDF3",
      500: "#039855",
      700: "#067949"
    },
    transparent: "transparent",
    orange: {
      400: "#FB923C"
    }
}

// ----------------- TBD ------------------------ //

export const brandColors = {
    primary: '#1677FF80',
    primaryLight: '#6b7a8f',
    primaryDark: '#4a5a6e',

    secondary: '#8b9dc3',
    secondaryLight: '#a0b1d0',
    secondaryDark: '#7688b6',

    success: '#52c41a',
    successLight: '#73d13d',
    successDark: '#389e0d',

    warning: '#faad14',
    warningLight: '#ffc53d',
    warningDark: '#d48806',

    error: '#ff4d4f',
    errorLight: '#ff7875',
    errorDark: '#f5222d',

    info: '#1890ff',
    infoLight: '#40a9ff',
    infoDark: '#096dd9',
};

export const neutralColors = {
    light: {
        text: {
            primary: '#111',
            secondary: '#666',
            tertiary: '#999',
            disabled: '#ccc',
            inverse: '#fff',
        },
        background: {
            primary: '#fff',
            secondary: '#f5f5f5',
            tertiary: '#fafafa',
            disabled: '#e8e8e8',
            overlay: 'rgba(0,0,0,0.5)',
        },
        border: {
            default: '#d9d9d9',
            light: '#f0f0f0',
            strong: '#bfbfbf',
        },
    },
    dark: {
        text: {
            primary: '#e6e6e6',
            secondary: '#a6a6a6',
            tertiary: '#666',
            disabled: '#444',
            inverse: '#111',
        },
        background: {
            primary: '#0f0f0f',
            secondary: '#1a1a1a',
            tertiary: '#141414',
            disabled: '#2a2a2a',
            overlay: 'rgba(0,0,0,0.8)',
        },
        border: {
            default: '#434343',
            light: '#2a2a2a',
            strong: '#666',
        },
    },
};

export const getColors = (isDark: boolean) => ({
    ...colorPalette,
    ...neutralColors[isDark ? 'dark' : 'light'],
});

export const buttonColors = {
    primary: {
        background: colorPalette.primary[600],
        text: colorPalette.white,
        border: colorPalette.primary[500],
        hover: colorPalette.primary[400],
        active: colorPalette.primary[600],
        disabled: colorPalette.gray[300],
    },
    secondary: {
        background: 'transparent',
        text: colorPalette.primary[700],
        border: colorPalette.primary[700],
        hover: colorPalette.primary[100],
        active: colorPalette.primary[700],
        disabled: colorPalette.gray[300],
    },
    success: {
        background: colorPalette.success[500],
        text: colorPalette.white,
        border: colorPalette.success[500],
        hover: colorPalette.success[700],
        active: colorPalette.success[700],
        disabled: colorPalette.gray[300],
    },
    warning: {
        background: colorPalette.warning[500],
        text: colorPalette.black,
        border: colorPalette.warning[500],
        hover: colorPalette.warning[700],
        active: colorPalette.warning[700],
        disabled: colorPalette.gray[300],
    },
    danger: {
        background: colorPalette.error[500],
        text: colorPalette.white,
        border: colorPalette.error[500],
        hover: colorPalette.error[700],
        active: colorPalette.error[700],
        disabled: colorPalette.gray[300],
    },
    ghost: {
        light: {
            background: 'transparent',
            text: colorPalette.primary[500],
            border: colorPalette.primary[500],
            hover: colorPalette.gray[100],
            active: colorPalette.primary[100],
        },
        dark: {
            background: 'transparent',
            text: colorPalette.gray[200],
            border: colorPalette.gray[400],
            hover: colorPalette.gray[500],
            active: colorPalette.gray[400],
        },
    },
};

export default {
    colorPalette,
    brandColors,
    neutralColors,
    buttonColors,
    getColors,
};
